export default "__VITE_ASSET__dgI0y0$D__"